import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

const DEFAULT_COMMIT = 'production';

const normalizeRow = createShapeNormalizer({
	type: 'object',
	shape: {
		enabled: { type: 'boolean' },
		// optional so a gate-only row (`{"enabled": true}`) normalizes instead of falling back to the default
		promptId: { type: 'string', optional: true },
		commit: { type: 'string', optional: true },
	},
});

export const FCM_CONTACT_DECISION_MAKER = defineFcm('contact_decision_maker')
	// The default merge takes the most specific row as-is, so a row that omits `commit` (or carries the
	// blank one the old template pre-filled) has to fall back to the production prompt here.
	.asJson((value: unknown) => {
		const row = normalizeRow(value);
		return { ...row, commit: row.commit || DEFAULT_COMMIT };
	})
	.withDefault({
		enabled: false,
		promptId: '',
		commit: DEFAULT_COMMIT,
	})
	.toConfig({
		owner: 'squad-vaquita',
		scope: ['corgi-middle-end'],
		context: 'Supporter → DM Outreach',
		description:
			'Rollout gate and LangSmith prompt pointer for the Supporter → DM Outreach draft step. A single global row is enough: set `enabled: true` plus `promptId` (and optionally `commit`, which defaults to "production") to re-point the prompt without a redeploy. A country or locale row replaces the whole object for that scope (most specific row wins).',
		template: {
			enabled: false,
			promptId: '',
			commit: DEFAULT_COMMIT,
		},
	});
